import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { count, none } from '@utils/summaries';
import { basicSort } from '@utils/sort';
import { useRange } from '@hooks/useRange';
import { styleDateRange } from '@utils/styles';
import { REPORT } from '@consts/reports';

interface CutsByCategoryLocationProps {
    dateRange: { startDate: string; endDate: string };
}

export const CutsByCategoryLocation = ({ dateRange }: CutsByCategoryLocationProps) => {
    const [range, setRange] = useRange('CutsByCategoryLocation');

    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.CUT_BY_CATEGORY_LOCATION,
        params: { range, ...dateRange },
        v2: true,
    });

    return (
        <BaseReport
            title={'Cuts by Category and Location'}
            description={
                'This report shows the number of successful cuts by device category and location. The table below provides a detailed breakdown of the data.'
            }
            loading={loading}
            hasData={hasData}
            setRange={setRange}
            rangeText={styleDateRange([dateRange.startDate, dateRange.endDate])}
            range={range}
            tableOptions={{
                headers: ['Company Name', 'Location Name', 'Category', 'Count'],
                data: data.map((item) => [item.companyName, item.locationName, item.category, item.count]),
                summaries: [count, none, none, none],
                sort: [basicSort, basicSort, basicSort, basicSort],
            }}
        />
    );
};
